// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import echarts from 'echarts'
import VueI18n from 'vue-i18n'
import VueColor from 'vue-color'
import './assets/main.css'
import {
  Upload,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Table,
  TableColumn,
  DatePicker
} from 'element-ui'
Vue.use(Upload)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(VueI18n);
Vue.use(VueColor)
Vue.use(Vant);

// 将axios实例挂载到Vue原型上，方便在组件中使用
Vue.prototype.$http = Axios;

Vue.config.productionTip = false
if (process.env.NODE_ENV == 'development') {
  Vue.prototype.$build = '/build';
} else {
  // Vue.prototype.$build = `${window.location.protocol}//www.bunchparty.com/menub`;
  // Vue.prototype.$build = 'http://8.210.169.110/menub'; //新服务器
  Vue.prototype.$build = 'https://www.fastpoint.online'; // 新的正式服务器
}
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = Axios;
Vue.prototype.sessionStorage = sessionStorage;
Vue.prototype.localStorage = localStorage;


Vue.filter('formateDate', function (value) {
  if (!value) return '';
  value = value.toString();
  value = value.split(' ');
  return value[0];
});
Vue.filter('formatDate1', function (value) {
  if (!value) {
    return '';
  } else {
    var date = new Date(value);
    var Y = date.getFullYear() + '/';
    var M = (date.getMonth() + 1) + '/';
    var D = date.getDate();

    // var h = date.getHours().padStart(2,0)+ ':';

    // var m = date.getMinutes.padStart(2,0)+ ':';

    // var  s = date.getSeconds().padStart(2,0);

    return Y + M + D;
  }

});

//多语言
const i18n = new VueI18n({
  locale: localStorage.getItem('langs') || 'en',
  messages: {
    'zh': require('./assets/common/lang/zh'), // 中文语言包
    'en': require('./assets/common/lang/en'), // 英文语言包
    'hk': require('./assets/common/lang/hk') // 中文繁体
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App,
    Upload
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js